import { action } from 'easy-peasy';
import OrgContextModel from './types/OrgContextModel';

const orgContextModel: OrgContextModel = {
  orgId: undefined,
  contactId: undefined,
  salesforceId: undefined,
  collectionHandle: undefined,
  primaryColor: undefined,
  textColorOverride: undefined,
  navbar: undefined,
  perPage: undefined,
  setContext: action((state, payload) => {
    Object.assign(state, payload);
  }),
  reset: action(state => {
    state.orgId = undefined;
    state.contactId = undefined;
    state.salesforceId = undefined;
    state.collectionHandle = undefined;
    state.primaryColor = undefined;
    state.textColorOverride = undefined;
    state.navbar = undefined;
    state.perPage = undefined;
  }),
};

export default orgContextModel;
